/**
 * @module byo-bundle/render
 * Reflects slot state in the DOM. Prices are pre-rendered by Liquid on each
 * card; this only clones card nodes and toggles classes.
 */

import { CLASSES, SELECTORS } from './constants.js';
import { filledCount, isComplete, type Slots } from './state.js';

/** Fills or empties one slot row, and marks the selected card in its drawer. */
export function renderSlot(slot: HTMLElement, variantId: number | null) {
  const pick = slot.querySelector<HTMLElement>(SELECTORS.pick)!;
  const cards = slot.querySelectorAll<HTMLElement>(SELECTORS.card);
  const card = [...cards].find((c) => Number(c.dataset.variantId) === variantId);

  cards.forEach((c) => c.classList.toggle(CLASSES.selected, c === card));
  slot.classList.toggle(CLASSES.filled, Boolean(card));
  pick.replaceChildren(
    ...(card ? [...card.querySelectorAll(SELECTORS.cardClone)].map((n) => n.cloneNode(true)) : []),
  );

  // Name the row's basket and Remove after the product, so they differ between rows.
  const title = card?.querySelector(SELECTORS.cardTitle)?.textContent?.trim();
  if (title) {
    slot.querySelectorAll<HTMLElement>(SELECTORS.rowLabelled).forEach((button) =>
      button.setAttribute(
        'aria-label',
        button.dataset.template!.replace('[product]', () => title),
      ),
    );
  }
}

/** Updates the counter, its live region, the next empty slot, the complete class and the CTA. */
export function renderSummary(root: HTMLElement, slots: Slots) {
  const count = filledCount(slots);
  const complete = isComplete(slots);
  const counter = root.querySelector<HTMLElement>(SELECTORS.counter);
  const countEl = root.querySelector(SELECTORS.count);

  // The slots and CTA blocks are optional in the editor.
  if (countEl) countEl.textContent = String(count);
  if (counter) counter.textContent = counter.dataset.template!.replace('[count]', String(count));
  root
    .querySelectorAll(SELECTORS.slot)
    .forEach((slot, i) => slot.classList.toggle(CLASSES.next, i === slots.indexOf(null)));
  root.classList.toggle(CLASSES.complete, complete);

  // Never clear aria-disabled mid-add: it is also setLoading's double-submit guard.
  const submit = root.querySelector<HTMLElement>(SELECTORS.submitButton);
  if (!complete) submit?.setAttribute('aria-disabled', 'true');
  else if (!submit?.classList.contains(CLASSES.loading)) submit?.removeAttribute('aria-disabled');
}
